import { useEffect, useState, useRef } from 'react';
import Plot from 'react-plotly.js';
import LazyPlot from './lazyplot';

export default function Kegaki(props) {
    function initializelayout() {
        var alayout = {
            margin: { t: 0, b: 0, l: 0, r: 0 },
            modebardisplay: false,
            font: {
                size: 10
            },
            autosize: false,
            width: props.height,
            height: props.height,
            showlegend: false,
            scene: {
                aspectmode: "manual",
                aspectratio: {
                    x: 1, y: 1, z: 1,
                },
                camera: {
                    up: {
                        x: 0, y: 1, z: 0,
                    },
                    center: {
                        x: 0, y: 0, z: 0,
                    },
                    eye: {
                        x: 0, y: 0, z: 2.5,
                    },
                },
                xaxis: { range: [- props.maxval, props.maxval] },
                yaxis: { range: [- props.maxval, props.maxval] },
                zaxis: { range: [- props.maxval, props.maxval] },
            },
        }
        setLayout(alayout);
    }
    const [data, setData] = useState([]);
    const [layout, setLayout] = useState({});
    useEffect(() => {
        initializelayout()
    },[props.maxval,props.height])

    useEffect(() => {
        //propsのままではダブルクリックリセットが効かない
        var data1 = props.windata.x.concat();
        var data2 = props.windata.y.concat();
        var data3 = props.windata.z.concat();
        var markerSize = 1.0
        var trace = {
            x: data1, y: data2, z: data3,
            mode: "lines",
            type: 'scatter3d',
            name: '1F',
            marker: {
                size: markerSize,
                color: "#000"
            },
            line: {
                width: 1.0,
                color: "#000"
            },

            opacity: 0.5,
        };
        //軸最大値
        setData([trace]);
    }, [props.windata,layout])

    return (
        <div style={{height:props.height, position:"relative"}} onDoubleClick={(e) =>  initializelayout()}>
            <LazyPlot
                data={data}
                layout={layout}
                config={{ displayModeBar: false }}
            />
            <div style={{position: "absolute", right:"0.5em", bottom:"0.125em", fontSize:"small"}}>(cm)</div>
        </div>
    );
}